<template>
    <div class="layout__position-left layout__width-100">

        <el-form :model="searchParams" status-icon :rules="rules" ref="searchParams">

            <div class="layout__padding-clear text__align-center layout__width-100">
                <div class="layout__search-field__insights-250px">
                    <p class="layout__margin__bottom-10 text__align-left">Month Range</p>
                    <el-form-item prop="salesDateRange">
                        <el-date-picker
                            v-model="searchParams.salesDateRange"
                            type="monthrange"
                            align="left"
                            start-placeholder="Start Month"
                            end-placeholder="End Month"
                            :picker-options="pickerOptions"
                            format="MM/yyyy"
                            value-format="MM/yyyy">
                        </el-date-picker>
                    </el-form-item>
                </div>
            </div>

        </el-form>

        <el-button class="button-red button__base button__insights" v-on:click="getSales('searchParams')">Refresh Data
        </el-button>

        <el-button class="button-teal button__base button__insights" :disabled="this.sales.length === 0" v-on:click="csv()">Download CSV
        </el-button>

        <el-button class="button-teal button__base button__insights" :disabled="this.sales.length === 0" v-on:click="downloadChart()">Download Chart
        </el-button>

        <el-button class="button-red button__base button__insights" v-on:click="updateData()">Update Data for This Month
        </el-button>

    </div>

</template>

<script>

    import Axios from 'axios';
    import moment from 'moment';
    import download from 'downloadjs';
    import {axios} from '@/mixins/Axios.js';
    import {csvDownloadHelper} from '@/mixins/CsvDownloadHelper.js';
    import {dataFormatter} from '@/mixins/DataFormatter.js';
    import barChartBase from '../../mixins/bar-chart-base.js';

    export default {
        name: "customerStatusSearch",
        mixins: [axios, csvDownloadHelper, dataFormatter],
        props: {
            searchParams: {},
            sales: []
        },
        data() {
            return {
                serviceRouteUrl: `${process.env.VUE_APP_INSIGHTSAPIHOST}`,
                exportDate: new Date().toLocaleDateString('en-GB') + '_sales.csv',
                downloadUrl: '',
                myChart: Object,
                pickerOptions: {
                    shortcuts: [{
                        text: 'This month',
                        onClick(picker) {
                            picker.$emit('pick', [new Date(), new Date()]);
                        }
                    }, {
                        text: 'This year',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date(new Date().getFullYear(), 0);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: 'Last 6 months',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setMonth(start.getMonth() - 6);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                }
            }
        },
        created() {
            console.log('CREATED')
            const date = new Date();
            date.setDate(date.getDate() - 7)
            console.log('created date')

            this.searchParams.salesDateRange[0] = moment().format('MM/YYYY');
            this.searchParams.salesDateRange[1] = moment().format('MM/YYYY');

            console.log(this.searchParams)
        },
        mounted() {
            console.log('MOUNTED');
            this.getSales('searchParams');
        },
        destroyed() {
            console.log('DESTROYED')
            this.searchParams.salesDateRange[0] = moment().format('MM/YYYY');
            this.searchParams.salesDateRange[1] = moment().format('MM/YYYY');

            console.log(this.searchParams)
        },
        beforeUpdate() {
            window.sessionStorage.setItem('_search', JSON.stringify(this.searchParams));
        },
        methods: {
            getSales(searchParams) {

                this.$refs[searchParams].validate((valid) => {
                    if (valid) {

                        console.log('before')
                        console.log(this.searchParams)

                        let searchTerms = Object.assign({}, this.searchParams)
                        console.log('searchTerms')
                        console.log(searchTerms)

                        console.log('after search is copied')
                        console.log(this.searchParams)

                        console.log('after search is copied - new object')
                        console.log(searchTerms)

                        var startDateArray = searchTerms.salesDateRange[0].split("/"),
                            startDate = moment(new Date(startDateArray[1], startDateArray[0] - 1, 1)).format('YYYY%2FMM%2FDD'),
                            endDateArray = searchTerms.salesDateRange[1].split("/"),
                            endDate = moment(new Date(endDateArray[1], endDateArray[0], 0)).format('YYYY%2FMM%2FDD'),
                            endpoint = this.serviceRouteUrl + '/api/v1/insights/order/GetCustomerStatus?startDate=' + startDate + '&endDate=' + endDate;

                        console.log(endpoint)

                        this.$parent.loading = true;

                        Axios.get(endpoint, this.returnHeaderUsingToken())
                        .then(response => {
                            var lookup = {},
                                result = [],
                                dates = [],
                                custNo = 0,
                                orderDate,
                                orders = response.data.customerStatus;
                            this.$parent.sales = orders;

                            var colours = [];
                            colours.push('#00303a');
                            colours.push('#007389');
                            colours.push('#4f93a8');
                            colours.push('#acc6d2');

                            var chartId = 'customer-status-chart';
                            var chartData = barChartBase;
                            chartData['data'].labels = [];
                            chartData['data'].datasets = [];
                            chartData['data'].colours = colours;

                            var monthNames = ["JANUARY", "FEBRUARY", "MARCH", "APRIL", "MAY", "JUNE", "JULY", "AUGUST", "SEPTEMBER", "OCTOBER", "NOVEMBER", "DECEMBER"];
                            for (var order, i = 0; order = orders[i++];) {
                                var orderDate = monthNames[order.orderMonth - 1].substr(0, 3) + ' ' + order.orderYear;

                                if (!(orderDate in lookup)) {
                                    lookup[orderDate] = 1;
                                    chartData['data'].labels.push(orderDate);
                                    dates.push(orderDate);
                                }
                            }

                            chartData['data'].datasets.push({});
                            chartData['data'].datasets[0] = {"label":"Active Customers", "data":[], "backgroundColor":[colours[0]], "hoverBackgroundColor":[colours[0]], "borderColor":["#a0b2cc"], "hoverBorderColor":["#1853a5"], "borderWidth":[1]};
                            chartData['data'].datasets[1] = {"label":"New Customers", "data":[], "backgroundColor":[colours[1]], "hoverBackgroundColor":[colours[1]], "borderColor":["#a0b2cc"], "hoverBorderColor":["#1853a5"], "borderWidth":[1]};
                            chartData['data'].datasets[2] = {"label":"Lapsed Customers", "data":[], "backgroundColor":[colours[2]], "hoverBackgroundColor":[colours[2]], "borderColor":["#a0b2cc"], "hoverBorderColor":["#1853a5"], "borderWidth":[1]};
                            chartData['data'].datasets[3] = {"label":"Reactivated Customers", "data":[], "backgroundColor":[colours[3]], "hoverBackgroundColor":[colours[3]], "borderColor":["#a0b2cc"], "hoverBorderColor":["#1853a5"], "borderWidth":[1]};

                            //lookup = {};
                            for (var order, i = 0; order = orders[i++];) {
                                chartData['data'].datasets[0].data.push(order.active);
                                chartData['data'].datasets[0].backgroundColor.push([colours[0]]);
                                chartData['data'].datasets[0].hoverBackgroundColor.push([colours[0]]);
                                chartData['data'].datasets[0].borderColor.push(["#a0b2cc"]);
                                chartData['data'].datasets[0].hoverBorderColor.push(["#1853a5"]);
                                chartData['data'].datasets[0].borderWidth.push([1]);

                                chartData['data'].datasets[1].data.push(order.new);
                                chartData['data'].datasets[1].backgroundColor.push([colours[1]]);
                                chartData['data'].datasets[1].hoverBackgroundColor.push([colours[1]]);
                                chartData['data'].datasets[1].borderColor.push(["#a0b2cc"]);
                                chartData['data'].datasets[1].hoverBorderColor.push(["#1853a5"]);
                                chartData['data'].datasets[1].borderWidth.push([1]);

                                chartData['data'].datasets[2].data.push(order.lapsed);
                                chartData['data'].datasets[2].backgroundColor.push([colours[2]]);
                                chartData['data'].datasets[2].hoverBackgroundColor.push([colours[2]]);
                                chartData['data'].datasets[2].borderColor.push(["#a0b2cc"]);
                                chartData['data'].datasets[2].hoverBorderColor.push(["#1853a5"]);
                                chartData['data'].datasets[2].borderWidth.push([1]);

                                chartData['data'].datasets[3].data.push(order.reactivated);
                                chartData['data'].datasets[3].backgroundColor.push([colours[3]]);
                                chartData['data'].datasets[3].hoverBackgroundColor.push([colours[3]]);
                                chartData['data'].datasets[3].borderColor.push(["#a0b2cc"]);
                                chartData['data'].datasets[3].hoverBorderColor.push(["#1853a5"]);
                                chartData['data'].datasets[3].borderWidth.push([1]);

                                /*var customer = order.assignment;

                                if (!(customer in lookup)) {
                                    lookup[customer] = 1;

                                    chartData['data'].datasets.push({});
                                    chartData['data'].datasets[custNo] = {"label":customer, "data":[], "backgroundColor":[colours[custNo]], "borderColor":[colours[custNo]], "borderWidth":"3", "fill":"false"};

                                    var filteredOrders = orders.filter(a=>a.assignment==customer);

                                    for (var date, j = 0; date = dates[j++];) {
                                        var filteredDate = filteredOrders.filter(a=>a.orderDate==date);
                                        if (filteredDate.length == 0) {
                                            chartData['data'].datasets[custNo].data.push(0);
                                        } else {
                                            chartData['data'].datasets[custNo].data.push(filteredDate[0].orderNetTotal);
                                        }
                                    }
                                    custNo++;
                                }*/
                            }

                            chartData['options'].scales.yAxes[0].ticks = {
                                beginAtZero: true,
                                padding: 25,
                                userCallback: function (value, index, values) {
                                    value = value.toString();
                                    value = value.split(/(?=(?:...)*$)/);
                                    value = value.join(',');
                                    return value;
                                }
                            };

                            chartData['options'].tooltips.callbacks = {
                                label: function (tooltipItem, data) {
                                    var label = data.datasets[tooltipItem.datasetIndex].label || '';
                                    return label + ': ' + tooltipItem.yLabel;
                                },
                                labelColor: function (tooltipItem, chart) {
                                    return {
                                        borderColor: 'white',
                                        backgroundColor: chart.data.colours[tooltipItem.datasetIndex]
                                    }
                                }
                            }

                            chartData['options'].animation = { onComplete: this.chartCompleted };

                            Chart.plugins.register({
                                beforeDraw: function(chartInstance) {
                                    var ctx = chartInstance.chart.ctx;
                                    ctx.fillStyle = "white";
                                    ctx.fillRect(0, 0, chartInstance.chart.width, chartInstance.chart.height);
                                }
                            });

                            Chart.defaults.global.defaultFontFamily = 'Lato';
                            var ctx = document.getElementById(chartId);
                            this.myChart = new Chart(ctx, {
                                type: chartData.type,
                                data: chartData.data,
                                options: chartData.options,
                            });

                            this.$nextTick(() => { // Loading should be closed asynchronously
                                this.$parent.loading = false;
                            });
                        })
                        .catch(error => {
                            if (error.response) {
                                this.$message.error('Sorry there has been an issue retrieving the information you requested.');
                            }

                            this.$nextTick(() => { // Loading should be closed asynchronously
                                this.$parent.loading = false;
                            });

                            this.$parent.sales = [];
                        })
                    } else {
                        return false;
                    }
                })
            },
            chartCompleted() {
                console.log("chartCompleted");
                this.downloadUrl = this.myChart.toBase64Image();
                console.log("this.downloadUrl=" + this.downloadUrl);
            },
            downloadChart() {
                download(this.downloadUrl);
            },
            csv() {
                var monthNames = ["JANUARY", "FEBRUARY", "MARCH", "APRIL", "MAY", "JUNE", "JULY", "AUGUST", "SEPTEMBER", "OCTOBER", "NOVEMBER", "DECEMBER"];

                const fields = [
                    {label: 'Year', value: 'orderYear'},
                    {label: 'Month', value: (row, field) => monthNames[row.orderMonth - 1]},
                    {label: 'New Customers', value: 'new'},
                    {label: 'Active Customers', value: 'active'},
                    {label: 'Lapsed Customers', value: 'lapsed'},
                    {label: 'Reactivated Customers', value: 'reactivated'}
                ];

                this.downloadCsv(this.exportDate, fields, this.sales)
            },
            updateData() {
                //TODO: call endpoint to update customer_status data for current month
                this.$message({
                    message: 'This functionality is not yet available.',
                    type: 'warning'
                });

            }
        }
    };
</script>